import { FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import { Actions, SwitchAnomaliesPropsType } from '../Audit.types';

export function SwitchAnomalies({ anomalyTypeViews, onSwitch }: SwitchAnomaliesPropsType) {
  return (
    <FormGroup row sx={{ mt: 3 }}>
      {anomalyTypeViews.map((type) => {
        return (
          <FormControlLabel
            key={type.label + type.count}
            control={
              <Switch
                onChange={(e, checked) =>
                  onSwitch({ type: checked ? Actions.SHOW : Actions.HIDE, payload: type.id })
                }
                defaultChecked
              />
            }
            disableTypography
            label={
              <>
                <Typography>{type.label}</Typography>
                <Typography sx={{ ml: 0.5, color: 'text.secondary' }}>({type.count})</Typography>
              </>
            }
          />
        );
      })}
    </FormGroup>
  );
}
